import "./App.css";
import { Route, Routes } from "react-router-dom";
import Quiz from "./quizPages/quiz/Quiz";
import Results from "./quizPages/Results";
import QuizFil from "./quizPagesFil/quiz/QuizFil";
import ResultsFil from "./quizPagesFil/ResultsFil";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Quiz />} />
      <Route path="/results/En" element={<Results />} />
      <Route path="/Fil" element={<QuizFil />} />
      <Route path="/results/Fil" element={<ResultsFil />} />
    </Routes>
  );
}

export default App;
